import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from '../../../basic-components/sw-modal-frame/sw-modal-frame.component';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { BdpService } from 'src/app/areas/bdp/bdp.service';

@Component({
  selector: 'app-sw-operator-modal',
  templateUrl: './sw-operator-modal.component.html',
  styleUrls: ['./sw-operator-modal.component.css']
})
export class SwOperatorModalComponent implements OnInit {

  /**
   * 动态创建组件传入的参数
   */
  @Input() param: any = {};

  /**
   * 动态创建组件的抛出事件
   */
  @Output() callback = new EventEmitter(); 

  /**
   * 指定执行人常量配置模态框
   * @ignore
   */
  @ViewChild("operatorModal") operatorModal: SwModalframeComponent;

  /**
   * 指定执行人的下拉多选框列表
   * @ignore
   */
  operatorList:any[] = []

  /**
   * 指定执行人的下拉多选框双向绑定的数据
   * @ignore
   */
  operators:any = ""

   /**
   * 指定执行人的下拉多选框选中的数据
   * @ignore
   */
  assigneeList:any

  /**
   * 模态框确认按钮状态,是否置灰,默认置灰
   * @ignore
   */
  disabled:boolean = true

  /**
   * 是使用复选组件还是单选组件，默认复选
   * @ignore
   */
  multi:string = 'multi'

  /**
   * headerLogo
   * @ignore
   */
  headerLogo:string = '选择审批/办理人'

  /**
   * label
   * @ignore
   */
  label:string = '审批/办理人'

  /**
   * 模态框选值是否是必填项，默认是2-->必填项，不选择用户点击确定会提示，如果是1-->不是必填，那么不选用户也可以点击确定
   * @ignore
   */
  required:number = 2

  constructor(
    public box: SwMassageBoxService, //提示信息
    private http: SwHttpClientService, //http请求
    private systemId: SystemIdService,
    private User: GetUserModelService, //获取用户服务
    private bdpService: BdpService, //请求服务 
  ) { }

  ngOnInit() {
    if(this.param.operatorIds == 'unitUser'){
      //如果是选择本单位用户
      this.getUnitUser()
    } else{
      //如果是选择指定人
      this.getUser()
    }
    if(this.param.required){
      this.required = this.param.required
    }
    if(this.param.operatorMulti){
      this.multi = this.param.operatorMulti
    }
    if(this.param.headerLogo){
      this.headerLogo = this.param.headerLogo
      this.label = this.param.label || this.headerLogo.substr(2,this.headerLogo.length-2)
    }
  }

   /**
   * 获取所有用户信息,得到 指定执行人的下拉列表 operatorList
   * @ignore
   */
  getUser(){
    //获取所有用户信息的接口要使用 queryUserList 而不是 queryPageList , 后者只有拥有权限才能使用
    let param1 = {systemId: this.systemId.getSystemId()}
    this.bdpService.getUserService().queryList(param1).subscribe(  //查询用户
      data => {
        if (data["code"] == 200) {
          let arr1 = []
          let result = data["data"]
          result.forEach(user => {
            //如果用户是启用状态,且用户Id数组中存在,就将该用户添加到下拉多选框列表中
            if(user.status && this.param.operatorIds.indexOf(user.userId) != -1){
              arr1.push({id:user.userId,text:user.displayName})
            }
          });
          //得到指定执行人模态框的下拉列表
          this.operatorList = arr1
           
          if(this.param.initData && this.param.initData.length){
            //多选组件存在要回显的数据
            this.operators = this.param.initData.join(',')
          }
          this.operatorModal.toggle()  //打开模态框
        }
      }
    )
  }
  
  /**
   * 获取本单位用户的下拉列表 operatorList
   * @ignore
   */
  getUnitUser(){
    let userId = this.User.getUser().userId;
    let systemId= this.systemId.getSystemId()
    this.http.Post(`${environment.seekerWebAPI}user/queryUserListWithOrganizeByUserId?userId=${userId}&systemId=${systemId}`,{})
    .subscribe(data=>{
      if (data["code"] == 200) {
        let arr1 = []
        let result = data["data"]
        result.forEach(user => {
          //如果用户是启用状态,就将该用户添加到下拉多选框列表中
          if(user && user.status){
            arr1.push({id:user.userId,text:user.displayName})
          }
        });
        //得到指定执行人模态框的下拉列表
        this.operatorList = arr1
        
        if(this.param.initData && this.param.initData.length){
          //多选组件存在要回显的数据
          this.operators = this.param.initData.join(',')
        }
        this.operatorModal.toggle()  //打开模态框
      }
    })
  }
  
  /**
   * 指定执行人的下拉多选框选中项修改
   * @ignore
   */
  operatorListChange(event){
    if(this.multi == 'multi'){
      this.assigneeList = event
      if(this.assigneeList.length){
        //如果还存在勾选的用户就可以点击确认按钮
        this.disabled = false
      } else {
        //如果没有勾选用户就将确认按钮置灰
        this.disabled = true
      }

    } else if(this.multi == 'single'){
      this.assigneeList = [event.id]
      if(this.assigneeList.length){
        //如果还存在勾选的用户就可以点击确认按钮
        this.disabled = false
      } else {
        //如果没有勾选用户就将确认按钮置灰
        this.disabled = true
      }
    }
  }

  /**
   * 点击保存,关闭指定执行人模态框,进行审核操作
   * @ignore
   */
  sureOperator(){
    if(this.required == 2){
      if(this.assigneeList && this.assigneeList.length){
        //如果已经选择了指定执行人,就关闭模态框,然后进行审核操作
        this.operatorModal.toggle()  //关闭模态框
        this.callback.emit(this.assigneeList);  //抛出多选框选中的数据,会销毁组件,执行回调,且回调的参数就是 this.assigneeList
      } else {
        this.box.danger("请选择指定执行人")
      }
    } else if(this.required == 1){
      this.operatorModal.toggle() //关闭模态框(要先关闭模态框再销毁组件)
      this.callback.emit(this.assigneeList)  //抛出选中的用户,销毁组件,执行回调,且回调的参数就是选中的用户
    }
    
  }

  /**
   * 点击关闭,关闭指定执行人模态框
   * @ignore
   */
  closeOperator(){
    this.operators = null  //下拉多选框双向绑定数据清空
    this.assigneeList = []  //清空选择的审批人
    this.operatorModal.toggle()  //关闭模态框
    this.callback.emit(false);  //抛出false,只销毁组件
  }

}
